"use strict";
/*!
// <copyright file="SyncManager.ts" company="Microsoft">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var reactGrid;
    (function (reactGrid) {
        var SYNCSTATE_NAME = "_RESERVED_SyncState";
        function implementsRowChangeAction(obj) {
            return obj && (obj.ActionType === 0 /* Change */ || obj.ActionType === 1 /* Create */) ? true : false;
        }
        var SyncManager = /** @class */ (function () {
            function SyncManager(context, dataSource) {
                var _this = this;
                this.context = context;
                this.dataSource = dataSource;
                this.pasteSave = function () {
                    // clear out the messaging div and hide it
                    _this.setRailsModeMessagingContent(null);
                    _this.IsPaused = false;
                    // send any data interactions for the current server row
                    _this.sendDataInteractions($dyn.value(_this.context.SelectedRowTrackingId), false);
                    // Move onto queued row changes if applicable
                    if (_this.hasQueuedRowChanges()) {
                        _this.processFirstQueuedRowChange(false);
                    }
                    else {
                        _this.RailsMode = false;
                    }
                };
                this.pasteDiscard = function () {
                    // clear out the messaging div and hide it
                    _this.setRailsModeMessagingContent(null);
                    _this.discardPendingChanges();
                    _this.RailsMode = false;
                    _this.IsPaused = false;
                    _this.context.dataVersion++;
                    _this.context.markedSelectedVersion++;
                    _this.context.renderReactListAsync();
                };
                this.msgBarAnimationEnd = function (event) {
                    if (event.propertyName !== "color") {
                        if (_this.reevaluateElementsAsync) {
                            _this.reevaluateElementsAsync.cancel();
                            _this.reevaluateElementsAsync = undefined;
                        }
                        _this.reevaluateSurroundingBlockingDiv();
                    }
                };
                if ($dyn.isServerBoundDataSource(dataSource)) {
                    this.modelCollection = dataSource.__boundDataSource;
                }
                this.IsPaused = false;
                this.currentMessagingContent = 0 /* None */;
                this.msgBarAnimationHandlersUsed = false;
                this.deletePending = false;
                this.reevaluateElements = true;
                this.surroundingBlockingDivShown = false;
                this.queuedRowChanges = [];
                this.allowedElements = [];
                this.queuedDataChanges = {};
                this.qtipOpenedByClick = false;
                this.pendingDependentRowActions = {};
                if (context) {
                    if (context.Root && context.Root && context.Root.Id) {
                        this.rootId = context.Root.Id;
                    }
                    if ($dyn.isObservable(context.SelectedRowTrackingId)) {
                        this.oldSelectedRowTrackingId = $dyn.value(context.SelectedRowTrackingId);
                        this.selectedRowObserver = $dyn.observe(context.SelectedRowTrackingId, function (newValue) {
                            // Active row changed
                            var resetPaused = false;
                            var oldSyncState = _this.getRowSyncState(_this.oldSelectedRowTrackingId);
                            if (oldSyncState === 2 /* Invalid */ || oldSyncState === 3 /* Waiting */) {
                                // reset state on previous server active row if it was invalid, since we successfully were able to leave it
                                if (_this.hasDataInteractions(_this.oldSelectedRowTrackingId)) {
                                    _this.setRowSyncState(_this.oldSelectedRowTrackingId, 1 /* Syncing */);
                                }
                                else {
                                    _this.setRowSyncState(_this.oldSelectedRowTrackingId, 0 /* None */);
                                }
                                resetPaused = true;
                            }
                            if (resetPaused || (_this.IsPaused && _this.context.getCollectionIndexFromTrackingId(_this.oldSelectedRowTrackingId) === -1)) {
                                // possible we were paused on invalid row that got deleted
                                // Turn on client rendering again
                                if (!_this.context.preemptiveClient) {
                                    _this.context.preemptiveClient = true;
                                    // Sync client active row to server since the client was not updating
                                    _this.context.resetInternalSelectedTrackingId();
                                }
                                // we are no longer paused on invalid row
                                _this.IsPaused = false;
                            }
                            if (!_this.PendingRowChangeAction && _this.queuedRowChanges.length === 0) {
                                // No queued row changes
                                if (_this.context) {
                                    _this.context.resetInternalSelectedTrackingId();
                                    if (_this.context.ControlLibGridRef) {
                                        _this.context.ControlLibGridRef.recalculateScrollTop();
                                    }
                                    _this.context.markedSelectedVersion++;
                                    _this.context.renderReactListAsync();
                                }
                            }
                            else if (newValue) {
                                // Don't need to render if there is only a PendingRowChange and no queuedRowChanges
                                var callRender = false;
                                if (_this.queuedRowChanges.length > 0) {
                                    // remove newvalue from queued row changes
                                    _this.removeQueuedRowChange(newValue, 0 /* Change */);
                                    callRender = true;
                                }
                                _this.sendDataInteractions(newValue);
                                _this.executeDependentRowActions(newValue);
                                if (_this.queuedRowChanges.length === 0 && _this.context.preemptiveClient) {
                                    // if there are no more queued row changes and the client and server are not in sync then queue a row change
                                    _this.syncClientRowToServer();
                                }
                                // if it is a client create row or delete its' command callback will handle calling the next one
                                if (_this.queuedRowChanges.length > 0 && !_this.isPendingRowActionCreate() && !_this.deletePending) {
                                    _this.processFirstQueuedRowChange(true);
                                }
                                else if (callRender && _this.context) {
                                    // When all queued row changes are finished make sure grid rendering is up to date
                                    _this.context.markedSelectedVersion++;
                                    _this.context.renderReactListAsync();
                                }
                            }
                            _this.oldSelectedRowTrackingId = newValue;
                        }, this, undefined, true);
                    }
                }
            }
            /**
             * Queue action that is dependent on a successful row change to the specified rowId
             */
            SyncManager.prototype.queueDependentRowAction = function (rowId, actionKey, action) {
                if (!this.pendingDependentRowActions[rowId]) {
                    this.pendingDependentRowActions[rowId] = {};
                }
                this.pendingDependentRowActions[rowId][actionKey] = action;
            };
            SyncManager.prototype.attachToggleMark = function (rowId, action) {
                if (this.pendingDependentRowActions[rowId] && this.pendingDependentRowActions[rowId].toggleMark) {
                    // 2 toggle marks would negate each other so just delete that dependent action
                    delete this.pendingDependentRowActions[rowId].toggleMark;
                }
                else {
                    this.queueDependentRowAction(rowId, "toggleMark", action);
                }
            };
            SyncManager.prototype.discardPendingDependentRowActions = function () {
                this.pendingDependentRowActions = {};
            };
            SyncManager.prototype.discardPendingChanges = function () {
                var _this = this;
                if (this.context) {
                    this.discardQueuedDataChanges($dyn.value(this.context.SelectedRowTrackingId));
                }
                if (this.hasQueuedRowChanges()) {
                    this.queuedRowChanges.forEach(function (value) {
                        if (value.rowId !== undefined) {
                            _this.discardQueuedDataChanges(value.rowId);
                            if (value.action.ActionType === 1 /* Create */ && _this.context) {
                                _this.context.deleteClientRow(value.rowId);
                            }
                        }
                    });
                    this.queuedRowChanges = [];
                }
                this.queuedDataChanges = {};
            };
            SyncManager.prototype.removeQueuedRowChange = function (rowId, actionType) {
                if (this.queuedRowChanges.length > 0) {
                    // remove newvalue from queued row changes
                    this.queuedRowChanges = this.queuedRowChanges.filter(function (value) {
                        // return true if it is not the row with the correct action type
                        return !(value.rowId === rowId && (actionType === 2 /* Either */ ||
                            value.action.ActionType === actionType));
                    });
                }
            };
            SyncManager.prototype.processFirstQueuedRowChange = function (useAsync) {
                var _this = this;
                if (this.queuedRowChanges.length > 0 && !this.queuedRowChanges[0].action.InProgress) {
                    if (useAsync) {
                        // Need async because you can't send out an interaction while processing incoming interactions
                        $dyn.async(function () {
                            if (_this.queuedRowChanges.length > 0) {
                                _this.queuedRowChanges[0].action.execute();
                                if (!implementsRowChangeAction(_this.queuedRowChanges[0].action)) {
                                    _this.queuedRowChanges.shift();
                                }
                            }
                        }, undefined, "Send next pending row change");
                    }
                    else {
                        this.queuedRowChanges[0].action.execute();
                        if (!implementsRowChangeAction(this.queuedRowChanges[0].action)) {
                            // Row create and change remove themselves from queued actions
                            // Just remove other actions types right after execution
                            this.queuedRowChanges.shift();
                        }
                    }
                }
            };
            SyncManager.prototype.changeRow = function (masterTrackingId, markMode, previousActiveRow, inputMode, activeColumnName) {
                var action = new RowChangeAction(masterTrackingId, markMode, previousActiveRow, inputMode, activeColumnName, this);
                if (this.PendingRowChangeAction || this.queuedRowChanges.length > 0 || this.IsPaused) {
                    this.queueRowChange(masterTrackingId, action);
                    // if previousActiveRow is invalid then send first pendingChangeRow
                    if (this.context && this.getRowSyncState(previousActiveRow) === 2 /* Invalid */ && previousActiveRow === $dyn.value(this.context.SelectedRowTrackingId)) {
                        this.queuedRowChanges[0].action.execute();
                    }
                }
                else {
                    // If changing row with the keyboard and the grid is read-only, queue the row change
                    if (this.context && inputMode === $dyn.ui.InputType.keyboard && !$dyn.value(this.context.AllowEdit)) {
                        this.queueRowChange(masterTrackingId, action, false);
                    }
                    else {
                        action.execute();
                    }
                }
            };
            SyncManager.prototype.createRow = function (masterTrackingId, markMode, previousActiveRow, activeColumnName) {
                var action = new RowCreateAction(masterTrackingId, markMode, previousActiveRow, $dyn.ui.InputType.keyboard, activeColumnName, this);
                if (this.PendingRowChangeAction || this.queuedRowChanges.length > 0 || this.IsPaused) {
                    this.queueRowChange(masterTrackingId, action);
                    // need to set created row's sync state to syncing so that it can be deleted through the qtip even if there are no data changes
                    this.setRowSyncState(masterTrackingId, 1 /* Syncing */);
                    // if previousActiveRow is invalid then send first pendingChangeRow
                    if (this.context && this.getRowSyncState(previousActiveRow) === 2 /* Invalid */ && previousActiveRow === $dyn.value(this.context.SelectedRowTrackingId)) {
                        this.queuedRowChanges[0].action.execute();
                    }
                }
                else {
                    action.execute();
                }
            };
            SyncManager.prototype.processLastQueuedRowChange = function () {
                if (this.queuedRowChanges.length > 0) {
                    // Process the last row change and clear the queue
                    this.queuedRowChanges[this.queuedRowChanges.length - 1].action.execute();
                    this.queuedRowChanges = [];
                }
            };
            SyncManager.prototype.changeData = function (rowId, controlName, action, undo) {
                // if:
                // - data change was on server active row
                // - and no pending row change
                // - and sync manager is not paused, or if it is paused for an invalid row, then allow data changes on that invalid row
                if (this.context && !this.PendingRowChangeAction && rowId === $dyn.value(this.context.SelectedRowTrackingId) &&
                    (!this.IsPaused || this.getRowSyncState(rowId) === 2 /* Invalid */)) {
                    action(rowId);
                }
                else {
                    // need to queue data change for when its' row becomes server active
                    this.RailsMode = true;
                    // set row state to syncing
                    if (!this.hasDataInteractions(rowId)) {
                        this.queuedDataChanges[rowId] = { updates: {}, changesCounter: 0 };
                        if (this.getRowSyncState(rowId) === 0 /* None */) {
                            this.setRowSyncState(rowId, 1 /* Syncing */);
                        }
                    }
                    else {
                        this.queuedDataChanges[rowId].changesCounter++;
                    }
                    var order = this.queuedDataChanges[rowId].changesCounter;
                    if (!this.queuedDataChanges[rowId].updates[controlName]) {
                        // first data change for this control on this row
                        this.queuedDataChanges[rowId].updates[controlName] = { sync: action, order: order, undo: undo };
                    }
                    else {
                        // overwrite existing pending data change
                        this.queuedDataChanges[rowId].updates[controlName].sync = action;
                        this.queuedDataChanges[rowId].updates[controlName].order = order;
                        this.queuedDataChanges[rowId].updates[controlName].undo = undo;
                    }
                }
            };
            SyncManager.prototype.getValidity = function (rowId, controlName, dataSourceName) {
                if (!this.context || !this.dataSource) {
                    return;
                }
                var rowIndex = this.context.getRowIndexFromTrackingId(rowId);
                var collectionData = $dyn.value(this.dataSource);
                var model = collectionData[rowIndex];
                if (model) {
                    var validityValueKey = "_VIRTUALIZED_" + controlName + "_Validity";
                    if ($dyn.serverForm && $dyn.serverForm.isModel(model) && dataSourceName && model.collectionName !== dataSourceName) {
                        model = model.getRelated(dataSourceName, rowIndex);
                    }
                    if ($dyn.serverForm && $dyn.serverForm.isModel(model)) {
                        return model.getValue(validityValueKey);
                    }
                    else {
                        return model[validityValueKey];
                    }
                }
            };
            SyncManager.prototype.setValidity = function (validityValue, rowId, controlName, dataSourceName) {
                if (!this.context || !this.dataSource) {
                    return;
                }
                var rowIndex = this.context.getCollectionIndexFromTrackingId(rowId);
                var collectionData = $dyn.value(this.dataSource);
                var model = collectionData[rowIndex];
                if ($dyn.serverForm && $dyn.serverForm.isModel(model) && dataSourceName && model.collectionName !== dataSourceName) {
                    model = model.getRelated(dataSourceName, rowIndex);
                }
                if (model) {
                    var validityValueKey = "_VIRTUALIZED_" + controlName + "_Validity";
                    if ($dyn.serverForm && $dyn.serverForm.isModel(model)) {
                        var currentValidity = model.getValue(validityValueKey);
                        var newValidity = $dyn.util.objectAssign({}, currentValidity, validityValue);
                        model.setValue(validityValueKey, newValidity, false, this.rootId);
                        $dyn.reactGrid.appliedVirtualizedProperty = true;
                    }
                    else {
                        var currentValidity = model[validityValueKey];
                        var newValidity = $dyn.util.objectAssign({}, currentValidity, validityValue);
                        model[validityValueKey] = newValidity;
                    }
                }
            };
            SyncManager.prototype.setDataVersion = function (rowId, controlName, dataSourceName) {
                if (!this.context || !this.dataSource) {
                    return;
                }
                var rowIndex = this.context.getCollectionIndexFromTrackingId(rowId);
                var collectionData = $dyn.value(this.dataSource);
                var model = collectionData[rowIndex];
                if ($dyn.serverForm && $dyn.serverForm.isModel(model) && dataSourceName && collectionData[rowIndex].collectionName !== dataSourceName) {
                    model = collectionData[rowIndex].getRelated && collectionData[rowIndex].getRelated(dataSourceName, rowIndex);
                }
                if (model) {
                    var dataVersionKey = "_VIRTUALIZED_" + controlName + "_DataVersion";
                    if ($dyn.serverForm && $dyn.serverForm.isModel(model)) {
                        var currentVersion = model.getValue(dataVersionKey);
                        if (currentVersion === undefined) {
                            currentVersion = 0;
                        }
                        model.setValue(dataVersionKey, currentVersion + 1, true, this.rootId);
                        $dyn.reactGrid.appliedVirtualizedProperty = true;
                    }
                    else {
                        var currentVersion = model[dataVersionKey];
                        if (currentVersion === undefined) {
                            currentVersion = 0;
                        }
                        model[dataVersionKey] = currentVersion + 1;
                    }
                }
            };
            SyncManager.prototype.setInternalValue = function (value, fieldName, dataSourceName, rowId) {
                if (rowId === void 0) { rowId = ""; }
                if (!this.context || !this.dataSource) {
                    return;
                }
                var rowIndex;
                if (rowId) {
                    rowIndex = this.context.getCollectionIndexFromTrackingId(rowId);
                }
                else {
                    rowIndex = this.context.getActiveRowCollectionIndex();
                }
                var collectionData = $dyn.value(this.dataSource);
                var model = collectionData[rowIndex];
                if (model) {
                    var pendingValue = "_INTERNAL_" + fieldName;
                    if ($dyn.serverForm && $dyn.serverForm.isModel(model)) {
                        if (dataSourceName && model.collectionName !== dataSourceName) {
                            var related = model.getRelated(dataSourceName, rowIndex);
                            if (related && related.doesPropertyExist(fieldName)) {
                                related.setValue(pendingValue, value, false, this.rootId);
                            }
                        }
                        else if (model.doesPropertyExist(fieldName)) {
                            model.setValue(pendingValue, value, false, this.rootId);
                        }
                    }
                    else {
                        model[pendingValue] = value;
                    }
                }
            };
            /**
             * Clear local internal value
             * @returns True if internal value is different than current field value
             */
            SyncManager.prototype.clearInternalValue = function (rowId, fieldName, dataSourceName) {
                var retVal = false;
                if (!this.context || !this.dataSource) {
                    return retVal;
                }
                var rowIndex = this.context.getCollectionIndexFromTrackingId(rowId);
                var collectionData = $dyn.value(this.dataSource);
                var model = collectionData[rowIndex];
                if (model) {
                    var pendingValue = "_INTERNAL_" + fieldName;
                    if ($dyn.serverForm && $dyn.serverForm.isModel(model)) {
                        if (dataSourceName && model.collectionName !== dataSourceName) {
                            var related = model.getRelated(dataSourceName, rowIndex);
                            if (related && related.doesPropertyExist(pendingValue)) {
                                if (related.getValue(fieldName) !== related.getValue(pendingValue)) {
                                    retVal = true;
                                }
                                related.removeProperty(pendingValue);
                            }
                        }
                        else if (model.doesPropertyExist(pendingValue)) {
                            if (model.getValue(fieldName) !== model.getValue(pendingValue)) {
                                retVal = true;
                            }
                            model.removeProperty(pendingValue);
                        }
                    }
                    else {
                        if (model[pendingValue] !== model[fieldName]) {
                            retVal = true;
                        }
                        delete model[pendingValue];
                    }
                }
                return retVal;
            };
            Object.defineProperty(SyncManager.prototype, "RailsMode", {
                get: function () {
                    return this.surroundingBlockingDivShown;
                },
                set: function (value) {
                    // Need to call render on the context because IsTabbingContainer prop is dependent on whether RailsMode is on/off
                    if (value && !this.surroundingBlockingDivShown) {
                        this.SurroundingBlockingDiv.show(this.AllowedElements);
                        this.surroundingBlockingDivShown = true;
                        if (this.context) {
                            this.context.renderReactListAsync();
                        }
                    }
                    else if (!value && this.surroundingBlockingDivShown) {
                        this.setRailsModeMessagingContent(null);
                        this.SurroundingBlockingDiv.hide();
                        this.surroundingBlockingDivShown = false;
                        this.cachedSurroundingBlockingDiv.removeClass("fadeInQuick");
                        this.cachedSurroundingBlockingDiv.removeClass("fastEditRailsMode");
                        if (this.context) {
                            this.context.renderReactListAsync();
                        }
                    }
                },
                enumerable: false,
                configurable: true
            });
            SyncManager.prototype.hasRailsModeMessagingContent = function () {
                if (this.surroundingBlockingDivShown && this.context) {
                    return this.SurroundingBlockingDiv.hasMessagingContent(this.context.element);
                }
            };
            SyncManager.prototype.setRailsModeMessagingContent = function (content) {
                if (this.surroundingBlockingDivShown && this.context) {
                    this.SurroundingBlockingDiv.addMessagingContent(this.context.element, content);
                }
                if (content === null) {
                    this.currentMessagingContent = 0 /* None */;
                }
            };
            SyncManager.prototype.fadeInBlockingDivs = function () {
                this.SurroundingBlockingDiv.addClass("fadeInQuick");
                this.SurroundingBlockingDiv.addClass("fastEditRailsMode");
            };
            SyncManager.prototype.setRowSyncState = function (rowId, syncState) {
                if (!this.context || !this.dataSource) {
                    return;
                }
                var rowIndex = this.context.getCollectionIndexFromTrackingId(rowId);
                var collectionData = $dyn.value(this.dataSource);
                var model = collectionData[rowIndex];
                if (model) {
                    if (model.getValue && model.getValue(SYNCSTATE_NAME) !== syncState) {
                        model.setValue(SYNCSTATE_NAME, syncState, false, this.rootId);
                    }
                    else {
                        model[SYNCSTATE_NAME] = syncState;
                    }
                    this.context.markedSelectedVersion++;
                    this.context.renderReactListAsync();
                }
            };
            SyncManager.prototype.getRowSyncState = function (rowId) {
                if (!this.context || !this.dataSource) {
                    return;
                }
                var retValue;
                var rowIndex = this.context.getCollectionIndexFromTrackingId(rowId);
                if (rowIndex > -1) {
                    var collectionData = $dyn.value(this.dataSource);
                    var model = collectionData[rowIndex];
                    if (model) {
                        if (model.getValue) {
                            retValue = model.getValue(SYNCSTATE_NAME);
                        }
                        else {
                            retValue = model[SYNCSTATE_NAME];
                        }
                    }
                }
                if (retValue === undefined) {
                    retValue = 0 /* None */;
                }
                return retValue;
            };
            SyncManager.prototype.hasQueuedRowChanges = function () {
                return (this.queuedRowChanges.length > 0);
            };
            SyncManager.prototype.doesRowChangeExist = function (rowId, actionType) {
                var e_1, _a;
                try {
                    for (var _b = __values(this.queuedRowChanges), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var rowChange = _c.value;
                        if (rowChange.rowId === rowId && (actionType === 2 /* Either */ || rowChange.action.ActionType === actionType)) {
                            return true;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return false;
            };
            SyncManager.prototype.queueRowChange = function (rowId, action, turnOnRailsMode, queueAtBeginning) {
                if (turnOnRailsMode === void 0) { turnOnRailsMode = true; }
                if (queueAtBeginning === void 0) { queueAtBeginning = false; }
                if (this.queuedRowChanges.length > 0) {
                    // don't remove a client created row
                    if (this.queuedRowChanges[this.queuedRowChanges.length - 1].action.ActionType === 0 /* Change */ &&
                        (this.hasDataInteractions() || this.IsPaused)) {
                        // if the last queued row change has no queued data interactions then remove it
                        // This is an optimization to not send row changes that have no effect
                        // We can only do this optimization if the user is editing ahead of the server or the sync manager is paused,
                        // because we do not allow multiselect in those two scenarios
                        var lastRowId = this.queuedRowChanges[this.queuedRowChanges.length - 1].rowId;
                        if (!this.hasDataInteractions(lastRowId) || Object.keys(this.queuedDataChanges[lastRowId].updates).length === 0) {
                            var removedRowChange = this.queuedRowChanges.pop();
                            if (action.previousActiveRow === removedRowChange.rowId) {
                                action.previousActiveRow = removedRowChange.action.previousActiveRow;
                            }
                        }
                    }
                    else if (this.queuedRowChanges[this.queuedRowChanges.length - 1].action.ActionType === 4 /* SaveRecord */) {
                        // A row change or create will do a save on its own so this save record isnt needed
                        this.queuedRowChanges.pop();
                    }
                }
                if (this.context && !this.doesRowChangeExist(rowId, 2 /* Either */) && rowId !== $dyn.value(this.context.SelectedRowTrackingId)) {
                    // if row change isn't queued already and not going to the server active row, queue it
                    // if a row create for a row id already exists we dont also need a row change to that row
                    if (queueAtBeginning) {
                        this.queuedRowChanges.unshift({ rowId: rowId, action: action });
                    }
                    else {
                        this.queuedRowChanges.push({ rowId: rowId, action: action });
                    }
                    if (turnOnRailsMode) {
                        this.RailsMode = true;
                    }
                }
            };
            SyncManager.prototype.toggleMarkAll = function (newMarkAllValue) {
                var toggleMarkAllAction = new ToggleMarkAllAction(newMarkAllValue, this);
                if (this.hasQueuedRowChanges()) {
                    this.queuedRowChanges.push({ action: toggleMarkAllAction });
                }
                else {
                    toggleMarkAllAction.execute();
                }
            };
            SyncManager.prototype.markGroup = function (startTrackingId, endTrackingId, newIsMarked) {
                var groupMarkingAction = new GroupMarkAction(startTrackingId, endTrackingId, newIsMarked, this);
                if (this.hasQueuedRowChanges()) {
                    this.queuedRowChanges.push({ action: groupMarkingAction });
                }
                else {
                    groupMarkingAction.execute();
                }
            };
            SyncManager.prototype.unmarkAll = function () {
                var unmarkAllAction = new UnmarkAllAction(this);
                if (this.hasQueuedRowChanges()) {
                    this.queuedRowChanges.push({ action: unmarkAllAction });
                }
                else {
                    unmarkAllAction.execute();
                }
            };
            /**
             * Called when going to a gorup header row, decide if a save needs to be queued or executed
             */
            SyncManager.prototype.queueSaveIfNeeded = function () {
                var saveRecordAction = new SaveRecordAction(this);
                if (this.hasQueuedRowChanges()) {
                    var lastRowChange = this.queuedRowChanges[this.queuedRowChanges.length - 1];
                    if (lastRowChange.rowId !== undefined && this.hasDataInteractions(lastRowChange.rowId)) {
                        // if previous row has data changes, queue a save record
                        this.queuedRowChanges.push({ action: saveRecordAction });
                    }
                }
                else if (this.context.hasDirtyDataSource()) {
                    // if there are no queued row changes and there is a dirty ds on the grid, execute a save record
                    saveRecordAction.execute();
                }
            };
            SyncManager.prototype.setResumeCallback = function (resumeCallback) {
                var _this = this;
                this.IsPaused = true;
                this.RailsMode = true;
                var executeImmediately = false;
                if (this.context) {
                    if ($dyn.value(this.context.SelectedRowTrackingId) === $dyn.value(this.context.InternalSelectedRowTrackingId)) {
                        executeImmediately = true;
                    }
                    else {
                        this.setRowSyncState($dyn.value(this.context.SelectedRowTrackingId), 3 /* Waiting */);
                    }
                }
                if (executeImmediately) {
                    resumeCallback && resumeCallback();
                    this.RailsMode = false;
                }
                else {
                    this.setRailsModeMessagingContent(this.getResumeContent());
                    this.currentMessagingContent = 3 /* Resume */;
                    this.resumeClicked = function () {
                        resumeCallback && resumeCallback();
                        _this.setRailsModeMessagingContent(null);
                        _this.RailsMode = false;
                    };
                }
            };
            SyncManager.prototype.resumeCallbackComplete = function () {
                if (this.hasQueuedRowChanges() || this.hasDataInteractions()) {
                    this.RailsMode = true;
                }
                if (!this.deletePending) {
                    // If this is a delete confirmation dialog then the delete callback will start processing changes so we don't have to do that here
                    this.IsPaused = false;
                    // send interactions async since this is called as apart of closing the popup that paused the grid
                    if (this.context) {
                        if (this.context.Root) {
                            this.context.Root.PendingGrid = undefined;
                        }
                        this.setRowSyncState($dyn.value(this.context.SelectedRowTrackingId), 0 /* None */);
                        this.sendDataInteractions($dyn.value(this.context.SelectedRowTrackingId), true);
                    }
                    if (!this.isPendingRowActionCreate()) {
                        this.processFirstQueuedRowChange(true);
                    }
                }
            };
            SyncManager.prototype.syncCellClicked = function (rowIndex, element) {
                var trackingId = this.context.getTrackingIdFromRowIndex(rowIndex);
                var syncState = this.getRowSyncState(trackingId);
                if (syncState === 3 /* Waiting */) {
                    if (this.resumeClicked) {
                        this.resumeClicked();
                        this.resumeClicked = undefined;
                    }
                }
                else {
                    var hideOptions = {
                        event: "unfocus",
                    };
                    var showOptions = {
                        event: "",
                        ready: true,
                    };
                    this.createQTip(rowIndex, trackingId, syncState, hideOptions, showOptions, element);
                    if (this.qtip) {
                        this.qtipOpenedByClick = true;
                    }
                }
            };
            SyncManager.prototype.syncCellHover = function (rowIndex, element) {
                if (this.qtip && this.qtipOpenedByClick) {
                    // if there is a syncing qtip that was opened by clicking it, hover should not open a new one and thus destroy this one
                    return;
                }
                var trackingId = this.context.getTrackingIdFromRowIndex(rowIndex);
                var syncState = this.getRowSyncState(trackingId);
                // If qtip was already opened by click, don't re-open it
                if (syncState !== 3 /* Waiting */) {
                    var hideDelay = 100;
                    var showDelay = 400;
                    if ($dyn.flags.disableAnimations) {
                        hideDelay = 0;
                        showDelay = 0;
                    }
                    var hideOptions = {
                        delay: hideDelay,
                        fixed: true,
                    };
                    var showOptions = {
                        delay: showDelay,
                        ready: true,
                    };
                    this.createQTip(rowIndex, trackingId, syncState, hideOptions, showOptions, element);
                }
            };
            SyncManager.prototype.updatePreviousRowInQueuedRowChanges = function (clientTrackingId, newTrackingId) {
                this.queuedRowChanges.forEach(function (rowChange) {
                    if (implementsRowChangeAction(rowChange.action)) {
                        if (rowChange.action.ActionType === 0 /* Change */ && rowChange.rowId === clientTrackingId) {
                            rowChange.rowId = newTrackingId;
                            rowChange.action.trackingId = newTrackingId;
                        }
                        else if (rowChange.action.previousActiveRow === clientTrackingId) {
                            rowChange.action.previousActiveRow = newTrackingId;
                        }
                    }
                });
            };
            SyncManager.prototype.mergeModels = function (clientTrackingId, newTrackingId) {
                var _this = this;
                if ($dyn.serverForm && this.context) {
                    if (this.context.modelCollectionIds.length > 0) {
                        this.context.modelCollectionIds.forEach(function (collectionId) {
                            var e_2, _a;
                            var collection = $dyn.serverForm.ModelManager.getModelCollection(collectionId, _this.rootId);
                            if (collection) {
                                var clientModelId = collection.name + "_" + clientTrackingId;
                                var clientModel = $dyn.serverForm.ModelManager.getModel(clientModelId, _this.rootId);
                                var newModelId = collection.name + "_" + newTrackingId;
                                var newModel = $dyn.serverForm.ModelManager.getModel(newModelId, _this.rootId);
                                // clientModel may not exist if there was a clearCache
                                if (clientModel && newModel) {
                                    var propertyNames = clientModel.getPropertyNames();
                                    try {
                                        for (var propertyNames_1 = __values(propertyNames), propertyNames_1_1 = propertyNames_1.next(); !propertyNames_1_1.done; propertyNames_1_1 = propertyNames_1.next()) {
                                            var propertyName = propertyNames_1_1.value;
                                            if (propertyName === SYNCSTATE_NAME ||
                                                propertyName.startsWith("_INTERNAL_") ||
                                                (propertyName.startsWith("_VIRTUALIZED") && propertyName.endsWith("_Validity"))) {
                                                newModel.setValue(propertyName, clientModel.getValue(propertyName), false, _this.rootId);
                                            }
                                        }
                                    }
                                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                                    finally {
                                        try {
                                            if (propertyNames_1_1 && !propertyNames_1_1.done && (_a = propertyNames_1.return)) _a.call(propertyNames_1);
                                        }
                                        finally { if (e_2) throw e_2.error; }
                                    }
                                    // If for some reason the new server row is already selected or marked dont override that
                                    if (clientModel.isSelected) {
                                        newModel.isSelected = true;
                                    }
                                    if (clientModel.isMarked) {
                                        newModel.isMarked = true;
                                    }
                                    if (clientModel.collectionIndex === newModel.collectionIndex) {
                                        // The server is putting the server model in the right position
                                        // since we send down the previous master tracking id
                                        clientModel.collectionIndex = newModel.collectionIndex + 1;
                                    }
                                    // remove client model from collection items
                                    collection.numberOfClientRows--;
                                    if ($dyn.isObservableArray(collection.items)) {
                                        collection.items.splice(clientModel.collectionIndex, 1);
                                    }
                                    $dyn.serverForm.ModelManager.deleteModel(clientModelId, _this.rootId);
                                }
                            }
                        });
                    }
                    else {
                        // not a server bound scenario
                        if ($dyn.value(this.context.InternalSelectedRowTrackingId) === clientTrackingId) {
                            $dyn.setValue(this.context, "InternalSelectedRowTrackingId", newTrackingId);
                        }
                    }
                }
            };
            /**
             * Possible we have no more row changes queued and want to sync client row to the server
             */
            SyncManager.prototype.syncClientRowToServer = function () {
                if (this.context) {
                    var clientValue = $dyn.value(this.context.InternalSelectedRowTrackingId);
                    var serverValue = $dyn.value(this.context.SelectedRowTrackingId);
                    // only send a change row for server backed rows
                    var syncCurrentRow = (serverValue !== clientValue && parseInt(clientValue, 10) >= 0);
                    if (syncCurrentRow) {
                        if (this.rootId && this.modelCollection && $dyn.serverForm) {
                            var model = $dyn.serverForm.ModelManager.getModel(this.modelCollection.name + "_" + clientValue, this.rootId);
                            if (model === undefined) {
                                // don't send a change row if this model doesn't exist (potentially just got deleted)
                                syncCurrentRow = false;
                            }
                        }
                        if (syncCurrentRow) {
                            this.changeRow(clientValue, $dyn.controls.List.MarkMode.select, serverValue, $dyn.ui.InputType.notSpecified, this.context.activeColumnName);
                        }
                    }
                }
            };
            SyncManager.prototype.sendDataInteractions = function (rowId, useAsync) {
                var _this = this;
                if (useAsync === void 0) { useAsync = true; }
                // if new value has queued data interactions, then sync them and then clear sync state
                if (this.hasDataInteractions(rowId)) {
                    // Need async because you can't send out an interaction while processing incoming interactions
                    var updateFunc = function () {
                        var e_3, _a;
                        // Check again just in case since this can be an async call
                        if (_this.queuedDataChanges[rowId]) {
                            var dataUpdates = [];
                            // put the updates in the correct order
                            for (var controlName in _this.queuedDataChanges[rowId].updates) {
                                if (_this.queuedDataChanges[rowId].updates[controlName]) {
                                    // TODO: do in a way that there isn't empty entries in the array
                                    dataUpdates[_this.queuedDataChanges[rowId].updates[controlName].order] = _this.queuedDataChanges[rowId].updates[controlName];
                                }
                            }
                            try {
                                for (var dataUpdates_1 = __values(dataUpdates), dataUpdates_1_1 = dataUpdates_1.next(); !dataUpdates_1_1.done; dataUpdates_1_1 = dataUpdates_1.next()) {
                                    var update = dataUpdates_1_1.value;
                                    update && update.sync(rowId);
                                }
                            }
                            catch (e_3_1) { e_3 = { error: e_3_1 }; }
                            finally {
                                try {
                                    if (dataUpdates_1_1 && !dataUpdates_1_1.done && (_a = dataUpdates_1.return)) _a.call(dataUpdates_1);
                                }
                                finally { if (e_3) throw e_3.error; }
                            }
                            delete _this.queuedDataChanges[rowId];
                        }
                        if (_this.getRowSyncState(rowId) === 1 /* Syncing */) {
                            _this.setRowSyncState(rowId, 0 /* None */);
                        }
                    };
                    if (useAsync) {
                        $dyn.async(updateFunc, undefined, "Sync any pending data changes for server active row");
                    }
                    else {
                        updateFunc();
                    }
                }
            };
            SyncManager.prototype.hasDataInteractions = function (rowId) {
                if (rowId === undefined) {
                    return (Object.keys(this.queuedDataChanges).length > 0);
                }
                return this.queuedDataChanges[rowId] ? true : false;
            };
            SyncManager.prototype.updateQueuedDataChanges = function (oldRowId, newRowId) {
                if (this.hasDataInteractions(oldRowId)) {
                    this.queuedDataChanges[newRowId] = this.queuedDataChanges[oldRowId];
                    delete this.queuedDataChanges[oldRowId];
                }
            };
            SyncManager.prototype.updatePendingDependentRowActions = function (oldRowId, newRowId) {
                if (this.pendingDependentRowActions[oldRowId]) {
                    this.pendingDependentRowActions[newRowId] = this.pendingDependentRowActions[oldRowId];
                    delete this.pendingDependentRowActions[oldRowId];
                }
            };
            SyncManager.prototype.getValidationContent = function () {
                var _this = this;
                var messagingContent = document.createElement("div");
                var messagingText = document.createElement("span");
                messagingText.innerText = $dyn.label("ReactGrid_ValidationPrompt");
                var messagingLink = document.createElement("a");
                messagingLink.href = "#";
                messagingLink.onclick = function (event) {
                    _this.context.goToActiveRow();
                    _this.context.setClientMarking(false);
                    _this.context.preemptiveClient = false;
                    _this.RailsMode = false;
                    return false;
                };
                messagingLink.innerText = $dyn.label("ReactGrid_InvalidRowLink");
                messagingContent.appendChild(messagingText);
                messagingContent.appendChild(messagingLink);
                return messagingContent;
            };
            SyncManager.prototype.showPastePrompt = function () {
                this.currentMessagingContent = 4 /* PastePrompt */;
                this.setRailsModeMessagingContent(this.getPasteMessagingContent());
                this.fadeInBlockingDivs();
            };
            /**
             * Recalculate blocking divs
             */
            SyncManager.prototype.reevaluateSurroundingBlockingDiv = function () {
                if (this.surroundingBlockingDivShown) {
                    this.reevaluateElements = true;
                    this.SurroundingBlockingDiv.removeClass("fadeInQuick");
                    this.SurroundingBlockingDiv.show(this.AllowedElements);
                    switch (this.currentMessagingContent) {
                        case 1 /* PleaseWait */:
                            this.setRailsModeMessagingContent(this.getPleaseWaitContent());
                            break;
                        case 3 /* Resume */:
                            this.setRailsModeMessagingContent(this.getResumeContent());
                            break;
                        case 2 /* Validation */:
                            this.setRailsModeMessagingContent(this.getValidationContent());
                            break;
                        case 4 /* PastePrompt */:
                            this.setRailsModeMessagingContent(this.getPasteMessagingContent());
                            break;
                    }
                }
            };
            /**
             * Handler for when row change fails due to a cache clear
             */
            SyncManager.prototype.cacheClearedRowChangeFail = function (collectionIndex, markMode, inputMode, activeColumnName) {
                var _this = this;
                $dyn.async(function () {
                    if (_this.context) {
                        var newTrackingId = _this.context.getTrackingIdFromCollectionIndex(collectionIndex);
                        var rowIndex = _this.context.getRowIndexFromTrackingId(newTrackingId);
                        // possible row wont be here on the client after a cache clear
                        if (rowIndex !== -1) {
                            // Need to go through the control to update the client correctly
                            _this.context.changeRow(rowIndex, activeColumnName, markMode, inputMode);
                        }
                        else {
                            _this.context.goToActiveRow();
                        }
                    }
                });
            };
            /**
             * Take action when changing/creating/saving a row failed
             * @returns True if we did the legacy behavior of going back to active row, otherwise false if
             * we did fast edit behavior
             */
            SyncManager.prototype.rowSaveFailed = function () {
                var forceLegacyBehavior = false;
                // set syncstate on server active row to invalid
                if (this.context) {
                    var serverRowId = $dyn.value(this.context.SelectedRowTrackingId);
                    var serverRowIndex = this.context.getRowIndexFromTrackingId(serverRowId);
                    if (serverRowIndex >= 0) {
                        this.setRowSyncState(serverRowId, 2 /* Invalid */);
                        if (!this.context.preemptiveClient ||
                            (!this.context.getAllowEditPropValue() && $dyn.value(this.context.Mode) === $dyn.ui.ListMode.list)) {
                            forceLegacyBehavior = true;
                        }
                        if (forceLegacyBehavior) {
                            // Force legacy behavior where crossing a save boundary with an error caused a lightbox
                            // This is because we took down rails mode because the issue on the active row could be outside of the grid
                            this.context.goToActiveRow();
                            $dyn.errorMessageBox({ Text: $dyn.label("BoundaryError") });
                            this.RailsMode = false;
                        }
                        else {
                            // set grid to paused
                            this.IsPaused = true;
                            // throw up rails mode around grid
                            this.RailsMode = true;
                            if (!this.hasRailsModeMessagingContent()) {
                                this.fadeInBlockingDivs();
                                this.setRailsModeMessagingContent(this.getValidationContent());
                                this.currentMessagingContent = 2 /* Validation */;
                            }
                        }
                    }
                }
                return forceLegacyBehavior;
            };
            SyncManager.prototype.onCacheClear = function () {
                var _this = this;
                if (this.PendingRowChangeAction &&
                    this.PendingRowChangeAction.ActionType === 0 /* Change */) {
                    this.PendingRowChangeAction.cacheCleared = true;
                }
                // if we get a modelcollection clear, clear all pending changes on server rows
                this.queuedRowChanges = this.queuedRowChanges.filter(function (value) {
                    return (value && value.rowId && parseInt(value.rowId, 10) < 0);
                });
                var dataChangesDeleted = false;
                Object.keys(this.queuedDataChanges).filter(function (value) {
                    return (value && parseInt(value, 10) > 0);
                }).forEach(function (serverRowId) {
                    delete _this.queuedDataChanges[serverRowId];
                    if (!dataChangesDeleted) {
                        dataChangesDeleted = true;
                    }
                });
                if (dataChangesDeleted) {
                    $dyn.info({ Message: $dyn.label("ReactGrid_UnsavedChanges"), Label: "ReactGrid_UnsavedChanges" }, this.context);
                }
                this.pendingDependentRowActions = {};
                if (!this.isPendingRowActionCreate()) {
                    this.PendingRowChangeAction = undefined;
                }
                if ($dyn.length(this.queuedRowChanges) <= 0) {
                    this.RailsMode = false;
                }
                this.IsPaused = false;
            };
            SyncManager.prototype.dispose = function () {
                this.qtip && this.destroyQtip();
                this.cachedSurroundingBlockingDiv && this.cachedSurroundingBlockingDiv.destroy();
                this.selectedRowObserver && this.selectedRowObserver.dispose();
                this.msgBarObserver && this.msgBarObserver.dispose();
                this.msgBarComputed && this.msgBarComputed.valueChanged.clearAllDependencies();
                if (this.msgBarAnimationHandlersUsed && this.context && this.context.Root && this.context.Root.MessageBar && this.context.Root.MessageBar.element) {
                    this.context.Root.MessageBar.element.removeEventListener("transitionend", this.msgBarAnimationEnd, false);
                    this.context.Root.MessageBar.element.removeEventListener("animationend", this.msgBarAnimationEnd, false);
                    this.context.Root.MessageBar.element.removeEventListener("webkitAnimationEnd", this.msgBarAnimationEnd, false);
                }
                this.queuedRowChanges = [];
                this.queuedDataChanges = {};
                this.context = null;
                this.dataSource = null;
                this.modelCollection = null;
            };
            SyncManager.prototype.isPendingRowActionCreate = function () {
                return (this.PendingRowChangeAction && this.PendingRowChangeAction.ActionType === 1 /* Create */);
            };
            SyncManager.prototype.executeDependentRowActions = function (rowId) {
                var _this = this;
                if (this.pendingDependentRowActions && this.pendingDependentRowActions[rowId]) {
                    $dyn.async(function () {
                        for (var dependentActionKey in _this.pendingDependentRowActions[rowId]) {
                            if (_this.pendingDependentRowActions[rowId][dependentActionKey]) {
                                _this.pendingDependentRowActions[rowId][dependentActionKey]();
                            }
                        }
                        delete _this.pendingDependentRowActions[rowId];
                    }, undefined, "Send dependent row actions after row changed successfully");
                }
            };
            SyncManager.prototype.destroyQtip = function () {
                if (this.qtip) {
                    this.qtip.destroy(true);
                }
                this.qtip = null;
                this.qtipOpenedByClick = false;
            };
            SyncManager.prototype.createQTip = function (rowIndex, trackingId, syncState, hideOptions, showOptions, element) {
                var _this = this;
                if (!this.context || !element) {
                    return;
                }
                this.destroyQtip();
                var textContent = null;
                var toolbar = null;
                var showQtip = false;
                switch (syncState) {
                    case 2 /* Invalid */:
                        showQtip = true;
                        var _a = this.getToolbarWithGroup(), invalidQtipToolbar = _a.toolbar, invalidQtipToolbarGroup = _a.toolbarGroup;
                        this.getRevertButton(trackingId, invalidQtipToolbarGroup);
                        this.getDeleteButton(trackingId, invalidQtipToolbarGroup);
                        if (this.context.getColumnMessages(rowIndex).length !== 0) {
                            invalidQtipToolbar.classList.add("message");
                            textContent = $(this.getMessagesGroup(rowIndex)).add(invalidQtipToolbar);
                        }
                        else {
                            textContent = $(invalidQtipToolbar);
                        }
                        toolbar = $dyn.context(invalidQtipToolbar);
                        break;
                    case 1 /* Syncing */:
                        showQtip = true;
                        var _b = this.getToolbarWithGroup(), syncQtipToolbar = _b.toolbar, syncQtipToolbarGroup = _b.toolbarGroup;
                        // show revert button for server backed rows and a delete for client only rows
                        if (parseInt(trackingId, 10) >= 0) {
                            this.getRevertButton(trackingId, syncQtipToolbarGroup);
                        }
                        else {
                            this.getDeleteButton(trackingId, syncQtipToolbarGroup);
                        }
                        textContent = $(syncQtipToolbar);
                        toolbar = $dyn.context(syncQtipToolbar);
                        break;
                }
                if (showQtip) {
                    if (toolbar) {
                        // hide overflow button by default and have the _updateOverflow call in visible event handler show it if necessary
                        var overflowButton = toolbar.element.querySelector(".toolbar-overflow");
                        if (overflowButton) {
                            overflowButton.style.display = "none";
                        }
                    }
                    this.qtip = $(element).qtip({
                        content: {
                            text: textContent,
                        },
                        events: {
                            hide: function (event, api) {
                                _this.destroyQtip();
                                $(document.body).off("resetShellOnNavigation.syncQtip");
                            },
                            visible: function (event, api) {
                                if (toolbar) {
                                    toolbar._updateOverflow();
                                }
                                $(document.body).on("resetShellOnNavigation.syncQtip", function () {
                                    _this.destroyQtip();
                                });
                            },
                        },
                        hide: hideOptions,
                        position: {
                            at: "center right",
                            my: "center left",
                        },
                        show: showOptions,
                        style: {
                            classes: "qtip-light syncColumn-qtip",
                            tip: {
                                corner: true,
                                height: 7,
                                width: 15,
                            },
                        },
                    }).qtip("api");
                }
            };
            SyncManager.prototype.getPasteMessagingContent = function () {
                var messagingContent = document.createElement("div");
                var messagingText = document.createElement("span");
                messagingText.innerText = $dyn.label("ReactGrid_PasteConfirmation");
                var savePasteChanges = document.createElement("button");
                savePasteChanges.className = "dynamicsButton button-isDefault";
                savePasteChanges.innerText = $dyn.label("ReactGrid_Save");
                savePasteChanges.addEventListener("click", this.pasteSave);
                var discardPasteChanges = document.createElement("button");
                discardPasteChanges.className = "dynamicsButton";
                discardPasteChanges.innerText = $dyn.label("ReactGrid_Discard");
                discardPasteChanges.addEventListener("click", this.pasteDiscard);
                var buttonDiv = document.createElement("div");
                buttonDiv.className = "pasteButtonGroup";
                buttonDiv.appendChild(savePasteChanges);
                buttonDiv.appendChild(discardPasteChanges);
                messagingContent.appendChild(messagingText);
                messagingContent.appendChild(buttonDiv);
                return messagingContent;
            };
            SyncManager.prototype.removeQueuedDataChanges = function (rowId) {
                if (this.hasDataInteractions(rowId)) {
                    delete this.queuedDataChanges[rowId];
                }
            };
            SyncManager.prototype.discardQueuedDataChanges = function (rowId) {
                if (this.hasDataInteractions(rowId)) {
                    for (var controlName in this.queuedDataChanges[rowId].updates) {
                        if (this.queuedDataChanges[rowId].updates[controlName] && this.queuedDataChanges[rowId].updates[controlName].undo) {
                            this.queuedDataChanges[rowId].updates[controlName].undo(rowId);
                        }
                    }
                    this.removeQueuedDataChanges(rowId);
                }
                if (this.getRowSyncState(rowId) === 1 /* Syncing */) {
                    this.setRowSyncState(rowId, 0 /* None */);
                }
            };
            SyncManager.prototype.getToolbarWithGroup = function () {
                var toolbar = $dyn.ui.createControl("Toolbar");
                var toolbarGroup = $dyn.ui.createChildControl("ToolbarGroup", {}, toolbar);
                return { toolbar: toolbar, toolbarGroup: toolbarGroup };
            };
            SyncManager.prototype.getRevertButton = function (trackingId, parentElement) {
                var _this = this;
                var buttonContent = $dyn.ui.createChildControl("Button", {
                    ButtonDisplay: $dyn.ui.ButtonDisplay.textWithImageLeft,
                    Click: function () {
                        var rowSyncState = _this.getRowSyncState(trackingId);
                        if (rowSyncState === 2 /* Invalid */) {
                            var form = _this.context ? _this.context.Root : undefined;
                            if (form && form.executeShortcuts) {
                                form.executeShortcuts(false, "Restore");
                            }
                            _this.IsPaused = false;
                            _this.setRowSyncState(trackingId, 0 /* None */);
                            if (!_this.context.preemptiveClient) {
                                _this.context.preemptiveClient = true;
                            }
                            if (_this.hasQueuedRowChanges()) {
                                _this.processFirstQueuedRowChange(true);
                            }
                            else {
                                _this.RailsMode = false;
                            }
                        }
                        else if (rowSyncState === 1 /* Syncing */) {
                            _this.discardQueuedDataChanges(trackingId);
                            _this.context.dataVersion++;
                        }
                        _this.context.markedSelectedVersion++;
                        _this.context.renderReactListAsync();
                        _this.destroyQtip();
                    },
                    ImageName: "Restore",
                    Label: $dyn.label("ReactGrid_Revert"),
                    Name: "SyncCellQtipRevert",
                }, parentElement, { tagName: "button" });
                return buttonContent;
            };
            SyncManager.prototype.getDeleteButton = function (trackingId, parentElement) {
                var _this = this;
                var buttonContent = $dyn.ui.createChildControl("Button", {
                    ButtonDisplay: $dyn.ui.ButtonDisplay.textWithImageLeft,
                    Click: function () {
                        _this.removeQueuedRowChange(trackingId, 2 /* Either */);
                        _this.removeQueuedDataChanges(trackingId);
                        var rowSyncState = _this.getRowSyncState(trackingId);
                        if (rowSyncState === 1 /* Syncing */) {
                            _this.context.deleteClientRow(trackingId);
                        }
                        else if (rowSyncState === 2 /* Invalid */) {
                            var afterDelete = function () {
                                _this.IsPaused = false;
                                if (!_this.context.preemptiveClient) {
                                    _this.context.preemptiveClient = true;
                                }
                                if (_this.hasQueuedRowChanges()) {
                                    if (_this.modelCollection) {
                                        // move client active row away from row that is being deleted
                                        _this.modelCollection.internalActiveMasterTrackingId(_this.queuedRowChanges[0].rowId);
                                    }
                                    _this.processFirstQueuedRowChange(true);
                                }
                                else {
                                    _this.RailsMode = false;
                                }
                                _this.deletePending = false;
                            };
                            var form = _this.context ? _this.context.Root : undefined;
                            if (form && form.executeShortcuts) {
                                _this.deletePending = true;
                                form.executeShortcuts(false, "DeleteRecord", undefined, afterDelete);
                            }
                            else {
                                _this.context.deleteClientRow(trackingId);
                                afterDelete();
                            }
                        }
                        _this.destroyQtip();
                    },
                    ImageName: "Delete",
                    Label: $dyn.label("ReactGrid_DeleteRow"),
                    Name: "SyncCellQtipDelete",
                }, parentElement, { tagName: "button" });
                return buttonContent;
            };
            SyncManager.prototype.getMessagesGroup = function (rowIndex) {
                var e_4, _a;
                var messages = this.context.getColumnMessages(rowIndex);
                var groupElement = $dyn.ui.createControl("Group");
                try {
                    for (var messages_1 = __values(messages), messages_1_1 = messages_1.next(); !messages_1_1.done; messages_1_1 = messages_1.next()) {
                        var message = messages_1_1.value;
                        $dyn.ui.createChildControl("Label", { Text: message }, groupElement, { tagName: "span" });
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (messages_1_1 && !messages_1_1.done && (_a = messages_1.return)) _a.call(messages_1);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                return groupElement;
            };
            Object.defineProperty(SyncManager.prototype, "SurroundingBlockingDiv", {
                get: function () {
                    var _this = this;
                    if (!this.cachedSurroundingBlockingDiv) {
                        var clickHandler = function () {
                            _this.fadeInBlockingDivs();
                            if (!_this.hasRailsModeMessagingContent()) {
                                _this.setRailsModeMessagingContent(_this.getPleaseWaitContent());
                                _this.currentMessagingContent = 1 /* PleaseWait */;
                            }
                        };
                        this.cachedSurroundingBlockingDiv = new $dyn.shell.multiElementSurroundingBlockingDiv(clickHandler);
                    }
                    return this.cachedSurroundingBlockingDiv;
                },
                enumerable: false,
                configurable: true
            });
            SyncManager.prototype.getPleaseWaitContent = function () {
                var _this = this;
                var messagingContent = document.createElement("div");
                var messagingText = document.createElement("span");
                messagingText.innerText = $dyn.label("ReactGrid_PleaseWaitPrompt");
                var messagingLink = document.createElement("a");
                messagingLink.innerText = $dyn.label("ReactGrid_DiscardUnsaved");
                messagingLink.href = "#";
                messagingLink.onclick = function (event) {
                    _this.pasteDiscard();
                    return false;
                };
                messagingContent.appendChild(messagingText);
                messagingContent.appendChild(messagingLink);
                return messagingContent;
            };
            SyncManager.prototype.getResumeContent = function () {
                var _this = this;
                var messagingContent = document.createElement("div");
                var messagingText = document.createElement("span");
                messagingText.innerText = $dyn.label("ReactGrid_ResumePrompt");
                var messagingLink = document.createElement("a");
                messagingLink.innerText = $dyn.label("ReactGrid_ProvideInputLink");
                messagingLink.href = "#";
                messagingLink.onclick = function (event) {
                    _this.context.goToActiveRow();
                    var serverRowIndex = _this.context.getRowIndexFromTrackingId($dyn.value(_this.context.SelectedRowTrackingId));
                    _this.syncCellClicked(serverRowIndex);
                    return false;
                };
                messagingContent.appendChild(messagingText);
                messagingContent.appendChild(messagingLink);
                return messagingContent;
            };
            Object.defineProperty(SyncManager.prototype, "AllowedElements", {
                /**
                 * Get the array of elements that will not be covered by the rails mode blocking divs
                 */
                get: function () {
                    var _this = this;
                    if (!this.context || !this.context.element) {
                        return;
                    }
                    // Allow the grid, message bar, and any related add or delete buttons to not be covered by the blocking divs in rails mode
                    if (this.reevaluateElements || !this.allowedElements || this.allowedElements.length === 0) {
                        this.allowedElements = [this.context.element];
                        var root = this.context.Root;
                        if (root) {
                            if (root.MessageBar) {
                                if (root.MessageBar.IsVisible()) {
                                    // Only add message bar element if it is visible, but need the animation events either way
                                    this.allowedElements.push(root.MessageBar.element);
                                }
                                if ($dyn.flags.disableAnimations) {
                                    // if no animations, then just observe expanded/visible observables
                                    if (!this.msgBarComputed) {
                                        this.msgBarComputed = $dyn.computed(function () {
                                            _this.context.Root.MessageBar.IsVisible();
                                            _this.context.Root.MessageBar.InfoExpanded();
                                            _this.context.Root.MessageBar.WarningExpanded();
                                            _this.context.Root.MessageBar.ErrorExpanded();
                                        });
                                        this.msgBarObserver = $dyn.observe(this.msgBarComputed, function () {
                                            if (_this.reevaluateElementsAsync) {
                                                _this.reevaluateElementsAsync.cancel();
                                            }
                                            _this.reevaluateElementsAsync = $dyn.async(function () {
                                                _this.reevaluateSurroundingBlockingDiv();
                                            });
                                        }, this, null, true);
                                    }
                                }
                                else {
                                    if (!this.msgBarAnimationHandlersUsed) {
                                        // if animations, then listen for the animations to stop as to when to calculate the blocking divs
                                        this.context.Root.MessageBar.element.addEventListener("transitionend", this.msgBarAnimationEnd, false);
                                        this.context.Root.MessageBar.element.addEventListener("animationend", this.msgBarAnimationEnd, false);
                                        this.context.Root.MessageBar.element.addEventListener("webkitAnimationEnd", this.msgBarAnimationEnd, false);
                                        // When the last message gets removed it doesn't use animation to close the message bar
                                        this.msgBarObserver = $dyn.observe(this.context.Root.MessageBar.IsVisible, function (newValue) {
                                            if (!$dyn.value(newValue)) {
                                                if (_this.reevaluateElementsAsync) {
                                                    _this.reevaluateElementsAsync.cancel();
                                                }
                                                _this.reevaluateElementsAsync = $dyn.async(function () {
                                                    _this.reevaluateSurroundingBlockingDiv();
                                                });
                                            }
                                        }, this, null, true);
                                        this.msgBarAnimationHandlersUsed = true;
                                    }
                                }
                            }
                            /*if (root.element) {
                              // TODO: need to be able to handle these commands on the client
                              // - new needs to create new client row
                              // - delete needs to be able to remove client rows, remove pending changes
                              // - queue server row deletion? Or only allow delete on server active row
                              const buttonElements = $(root.element).find('[data-dyn-role="CommandButton"]');
                              if (buttonElements && buttonElements.length) {
                                  for (const buttonElement of buttonElements) {
                                      const buttonContext = $dyn.context(buttonElement);
                                      // Add or Delete buttons with the same service boundary
                                      if (
                                        buttonContext && (buttonContext.Command === "DeleteRecord" || buttonContext.Command === "New") && $dyn.value(buttonContext.Visible) &&
                                        $dyn.value(buttonContext.ServiceBoundary) === $dyn.value(this.context.ServiceBoundary)
                                      ) {
                                          this.allowedElements.push(buttonElement);
                                      }
                                  }
                              }
                            }*/
                        }
                        this.reevaluateElements = false;
                    }
                    return this.allowedElements;
                },
                enumerable: false,
                configurable: true
            });
            return SyncManager;
        }());
        reactGrid.SyncManager = SyncManager;
        /* tslint:disable:max-classes-per-file */
        var RowAction = /** @class */ (function () {
            function RowAction(syncManager) {
                this.syncManager = syncManager;
                this.InProgress = false;
            }
            return RowAction;
        }());
        var SaveRecordAction = /** @class */ (function (_super) {
            __extends(SaveRecordAction, _super);
            function SaveRecordAction(syncManager) {
                var _this = _super.call(this, syncManager) || this;
                _this.callback = function (result) {
                    var convertedResult = $dyn.util.stringToBoolean(result);
                    if (convertedResult) {
                        if (!_this.syncManager.hasQueuedRowChanges()) {
                            _this.syncManager.RailsMode = false;
                        }
                    }
                    else {
                        _this.syncManager.rowSaveFailed();
                    }
                };
                _this.failureCallback = function () {
                    _this.callback(false);
                };
                _this.ActionType = 4 /* SaveRecord */;
                return _this;
            }
            SaveRecordAction.prototype.execute = function () {
                if (!this.syncManager.context || this.InProgress) {
                    return;
                }
                this.InProgress = true;
                $dyn.callFunction(this.syncManager.context.SaveRecord, this.syncManager.context, undefined, this.callback, undefined, // completeCallback,
                undefined, // beforeCallback,
                undefined, // throttleCallback,
                this.failureCallback);
            };
            return SaveRecordAction;
        }(RowAction));
        var UnmarkAllAction = /** @class */ (function (_super) {
            __extends(UnmarkAllAction, _super);
            function UnmarkAllAction(syncManager) {
                var _this = _super.call(this, syncManager) || this;
                _this.callback = function () {
                    if (!_this.syncManager.hasQueuedRowChanges() && _this.syncManager.context) {
                        _this.syncManager.context.setClientMarking(false);
                    }
                };
                _this.ActionType = 6 /* UnmarkAll */;
                return _this;
            }
            UnmarkAllAction.prototype.execute = function () {
                if (!this.syncManager.context || this.InProgress) {
                    return;
                }
                this.InProgress = true;
                $dyn.callFunction(this.syncManager.context.UnmarkAll, this.syncManager.context, undefined, this.callback, undefined, undefined, undefined, this.callback);
            };
            return UnmarkAllAction;
        }(RowAction));
        var ToggleMarkAllAction = /** @class */ (function (_super) {
            __extends(ToggleMarkAllAction, _super);
            function ToggleMarkAllAction(markAllValue, syncManager) {
                var _this = _super.call(this, syncManager) || this;
                _this.markAllValue = markAllValue;
                _this.callback = function () {
                    if (!_this.syncManager.hasQueuedRowChanges() && _this.syncManager.context) {
                        _this.syncManager.context.setClientMarking(false);
                    }
                };
                _this.ActionType = 5 /* ToggleMarkAll */;
                return _this;
            }
            ToggleMarkAllAction.prototype.execute = function () {
                if (!this.syncManager.context || this.InProgress) {
                    return;
                }
                this.InProgress = true;
                $dyn.callFunction(this.syncManager.context.SetMarkAllRecordsMode, this.syncManager.context, this.markAllValue, this.callback, undefined, undefined, undefined, this.callback);
            };
            return ToggleMarkAllAction;
        }(RowAction));
        var GroupMarkAction = /** @class */ (function (_super) {
            __extends(GroupMarkAction, _super);
            function GroupMarkAction(startTrackingId, endTrackingId, markValue, syncManager) {
                var _this = _super.call(this, syncManager) || this;
                _this.startTrackingId = startTrackingId;
                _this.endTrackingId = endTrackingId;
                _this.markValue = markValue;
                _this.callback = function () {
                    if (!_this.syncManager.hasQueuedRowChanges() && _this.syncManager.context) {
                        _this.syncManager.context.setClientMarking(false);
                    }
                };
                _this.ActionType = 3 /* GroupMarking */;
                return _this;
            }
            GroupMarkAction.prototype.execute = function () {
                if (!this.syncManager.context || this.InProgress) {
                    return;
                }
                this.InProgress = true;
                $dyn.callFunction(this.syncManager.context.UpdateGroupMarking, this.syncManager.context, [this.startTrackingId, this.endTrackingId, this.markValue], this.callback, undefined, undefined, undefined, this.callback);
            };
            return GroupMarkAction;
        }(RowAction));
        var RowChangeAction = /** @class */ (function (_super) {
            __extends(RowChangeAction, _super);
            function RowChangeAction(trackingId, markMode, previousActiveRow, inputMode, activeColumnName, syncManager) {
                var _this = _super.call(this, syncManager) || this;
                _this.trackingId = trackingId;
                _this.markMode = markMode;
                _this.previousActiveRow = previousActiveRow;
                _this.inputMode = inputMode;
                _this.activeColumnName = activeColumnName;
                _this.callback = function (result) {
                    var convertedResult = $dyn.util.stringToBoolean(result);
                    if (convertedResult) {
                        // success
                        _this.syncManager.PendingRowChangeAction = undefined;
                        if (_this.syncManager.context && _this.syncManager.context.Root) {
                            _this.syncManager.context.Root.PendingGrid = undefined;
                        }
                        // bring down rails mode divs if there are no more queued row changes
                        if (!_this.syncManager.hasQueuedRowChanges()) {
                            _this.syncManager.RailsMode = false;
                            if (_this.syncManager.context) {
                                _this.syncManager.context.setClientMarking(false);
                            }
                        }
                    }
                    else if (result === -1) {
                        // throttled
                        _this.syncManager.removeQueuedRowChange(_this.trackingId, 0 /* Change */);
                    }
                    else {
                        // failure
                        _this.syncManager.PendingRowChangeAction = undefined;
                        if (_this.syncManager.context && _this.syncManager.context.Root) {
                            _this.syncManager.context.Root.PendingGrid = undefined;
                        }
                        // Need to reset the InProgress flag if we are not removing the row change from the queue
                        _this.InProgress = false;
                        if (_this.cacheCleared) {
                            _this.syncManager.cacheClearedRowChangeFail(_this.collectionIndex, _this.markMode, _this.inputMode, _this.activeColumnName);
                        }
                        else {
                            var forcedLegacyBehavior = _this.syncManager.rowSaveFailed();
                            if (!forcedLegacyBehavior && !_this.syncManager.doesRowChangeExist(_this.trackingId, _this.ActionType)) {
                                // queue this row change if it isn't still in the queue
                                _this.syncManager.queueRowChange(_this.trackingId, _this, true, true);
                            }
                            _this.syncManager.discardPendingDependentRowActions();
                        }
                    }
                };
                _this.beforeExecuteCallback = function () {
                    _this.syncManager.PendingRowChangeAction = _this;
                    if (_this.syncManager.context) {
                        _this.collectionIndex = _this.syncManager.context.getCollectionIndexFromTrackingId(_this.trackingId);
                        if (_this.syncManager.context.Root) {
                            _this.syncManager.context.Root.PendingGrid = _this.syncManager.context;
                        }
                    }
                };
                _this.ActionType = 0 /* Change */;
                return _this;
            }
            RowChangeAction.prototype.execute = function () {
                if (!this.syncManager.context || this.InProgress) {
                    return;
                }
                this.InProgress = true;
                // Don't throttle row changes if the grid is editable because there might be edits done on that row
                var shouldThrottle = (this.inputMode === $dyn.ui.InputType.keyboard &&
                    !this.syncManager.context.getAllowEditPropValue());
                $dyn.callFunction(this.syncManager.context.ChangeSelectedIndex, this.syncManager.context, [
                    this.trackingId,
                    this.markMode,
                    this.previousActiveRow,
                    shouldThrottle,
                    this.callback,
                    undefined,
                    false,
                    this.beforeExecuteCallback,
                    true,
                ]);
                // TODO: do we need to call the select cell on each row change, or maybe just once when all the row changes are finshed?
                // if (this.activeColumnName) {
                //   $dyn.callFunction(this.syncManager.context.SelectCell, this, [this.trackingId, this.activeColumnName, $dyn.ui.InputType.notSpecified, true]);
                // }
            };
            return RowChangeAction;
        }(RowAction));
        var RowCreateAction = /** @class */ (function (_super) {
            __extends(RowCreateAction, _super);
            function RowCreateAction(trackingId, markMode, previousActiveRow, inputMode, activeColumnName, syncManager) {
                var _this = _super.call(this, trackingId, markMode, previousActiveRow, inputMode, activeColumnName, syncManager) || this;
                _this.failureCallback = function () {
                    _this.callback(false);
                };
                _this.commandCallback = function (result) {
                    if (result !== undefined) {
                        result = result.toString();
                    }
                    var success = (result !== "-1");
                    if (success) {
                        // merge client model into server model and clean up client model
                        _this.syncManager.mergeModels(_this.trackingId, result);
                        // Remove the create row from the queue
                        _this.syncManager.removeQueuedRowChange(_this.trackingId, 1 /* Create */);
                        // Update previous active rows if applicable
                        _this.syncManager.updatePreviousRowInQueuedRowChanges(_this.trackingId, result);
                        // update queued data changes for client row to be for the newly created server row
                        _this.syncManager.updateQueuedDataChanges(_this.trackingId, result);
                        _this.syncManager.updatePendingDependentRowActions(_this.trackingId, result);
                        // if newly created row is now the active row then send any queued data changes
                        if (_this.syncManager.context && result === $dyn.value(_this.syncManager.context.SelectedRowTrackingId)) {
                            if (_this.syncManager.hasDataInteractions(result)) {
                                _this.syncManager.sendDataInteractions(result);
                            }
                            else {
                                _this.syncManager.setRowSyncState(result, 0 /* None */);
                            }
                        }
                        if (!_this.syncManager.hasQueuedRowChanges()) {
                            _this.syncManager.syncClientRowToServer();
                        }
                        // send the next queued row change
                        _this.syncManager.processFirstQueuedRowChange(true);
                    }
                    else {
                        // Set sync state to syncing so that it can be deleted from the qtip
                        if (_this.syncManager.getRowSyncState(_this.trackingId) === 0 /* None */) {
                            _this.syncManager.setRowSyncState(_this.trackingId, 1 /* Syncing */);
                        }
                    }
                    _this.callback(success);
                    if (_this.syncManager.context && _this.syncManager.context.dataCache) {
                        _this.syncManager.context.dataCache.resetLoadDirection();
                    }
                };
                _this.beforeCallback = function () {
                    if (_this.syncManager.context && _this.syncManager.context.dataCache) {
                        _this.syncManager.context.dataCache.LoadDirection = $dyn.ui.ScrollDirection.down;
                    }
                    _this.beforeExecuteCallback();
                };
                _this.ActionType = 1 /* Create */;
                return _this;
            }
            RowCreateAction.prototype.execute = function () {
                if (!this.syncManager.context || this.InProgress) {
                    return;
                }
                this.InProgress = true;
                $dyn.callFunction(this.syncManager.context.CreateNewRecordOnKeyDown, this.syncManager.context, [this.markMode, this.previousActiveRow, this.trackingId, true], this.commandCallback, undefined, // completeCallback,
                this.beforeCallback, undefined, // throttleCallback,
                this.failureCallback);
            };
            return RowCreateAction;
        }(RowChangeAction));
    })(reactGrid = $dyn.reactGrid || ($dyn.reactGrid = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=SyncManager.js.map
